import React from 'react'
import { useStateValue } from '@State'

export function IncompleteBadgeImage() {
  const [state, dispatch] = useStateValue()

  const handleChange = newImage => {
    let newName = newImage.name
    let reader = new FileReader()
    reader.readAsDataURL(newImage)
    reader.onload = e => {
      dispatch({
        type: 'UPDATE_BADGE_INFO',
        badgeInfo: {
          incompleteImage: e.target.result,
          incompleteImageName: newName,
          incompleteImageLoaded: true,
          incompleteNewUploadedImage: true,
        },
      })
    }
  }

  return (
    <div className="image_info">
      <input
        type="file"
        id="image_input"
        accept=".png, .jpeg, .jpg"
        onChange={e => handleChange(e.target.files[0])}
      />
      <p>{state.badgeInfo.incompleteImageName ? state.badgeInfo.incompleteImageName : ''}</p>
    </div>
  )
}
